import { FlowStateManager } from '../flow-management/FlowStateManager';
import { Step } from '../views/Step';
export const setFlowAfterGoogleCredentialAuthentication = response => dispatch => {
  const stepsToRemove = [...(response.email ? [Step.LandingPage] : []), Step.Verification, Step.CodeVerification, Step.Password, ...(response.firstName && response.lastName ? [Step.Name] : [])];
  dispatch(FlowStateManager.removeSteps(...stepsToRemove));
};